(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Telephone : un message a la fois, toutes les 3,5 s. */
  document.querySelectorAll('[data-ann]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.ann__item')];
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Panier : modification des quantités via la Cart AJAX API, puis rechargement ; repli sur les liens classiques. */
  (() => {
    let busy = false;
    const getRoot = () => document.querySelector('[data-cart-root]');
    const countEl = document.querySelector('[data-cart-count]');

    // Le panier contient des carrousels et des boutons « compléter votre look » initialisés au chargement
    // (charms.js) : le plus fiable est de recharger la page après chaque modification.
    const refresh = () => location.reload();

    // Change la quantité d'une ligne ; renvoie false si le réseau échoue (repli sur le lien).
    async function change(key, quantity) {
      const root = getRoot();
      busy = true;
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${root.dataset.changeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        const data = await res.json();
        if (res.ok) { refresh(); return true; }
        root.querySelector('[data-cart-msg]').textContent = data.description || data.message || 'Impossible de modifier la quantité.';
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
        busy = false;
        return true;
      } catch {
        return false;
      }
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-cart-key]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (busy) return;
      const { cartKey, cartQty } = link.dataset;
      change(cartKey, Number(cartQty)).then((ok) => { if (!ok) location.href = link.href; });
    });

    // Code promo : Shopify applique le code via /discount/CODE puis renvoie vers le panier.
    function applyPromo() {
      const root = getRoot();
      const input = root?.querySelector('[data-promo-input]');
      if (!input) return;
      const code = input.value.trim().toUpperCase();
      if (!code) { input.focus(); return; }
      location.href = `${root.dataset.promoBase}${encodeURIComponent(code)}?redirect=${root.dataset.cartUrl}`;
    }
    document.addEventListener('click', (e) => { if (e.target.closest('[data-promo-apply]')) applyPromo(); });
    // Entrée dans le champ : on applique le code (et non la commande).
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-promo-input]')) { e.preventDefault(); applyPromo(); }
    });

    // Un ajout rapide depuis une carte du cross-sell modifie le compteur : on rafraîchit le panier.
    if (countEl) {
      new MutationObserver(() => {
        const root = getRoot();
        if (!busy && root && root.dataset.count !== countEl.textContent.trim()) refresh();
      }).observe(countEl, { childList: true, characterData: true, subtree: true });
    }
  })();

  /* Onglets de catégories sous le panier : un seul carrousel visible à la fois. */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.cart-tabs__tab');
    if (!tab) return;
    const box = tab.closest('.cart-tabs');
    box.querySelectorAll('.cart-tabs__tab').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    box.querySelectorAll('[role="tabpanel"]').forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    window.dispatchEvent(new Event('resize'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Collection : panneau de filtres (latéral sur mobile, déroulant sur ordinateur) et envoi automatique. */
  (() => {
    const form = document.querySelector('[data-coll-form]');
    document.querySelector('.coll-chip.is-active')?.scrollIntoView({ inline: 'center', block: 'nearest' });
    const dlg = form?.querySelector('dialog');
    const btn = form?.querySelector('[data-coll-open]');
    if (!dlg || !btn) return;

    const KEY = 'coll-filters-open';
    const mobile = matchMedia('(max-width: 749px)');
    const open = () => {
      if (dlg.open) return;
      if (mobile.matches) dlg.showModal(); else dlg.show();
      btn.setAttribute('aria-expanded', 'true');
    };
    const close = () => dlg.close();

    dlg.addEventListener('close', () => btn.setAttribute('aria-expanded', 'false'));
    btn.addEventListener('click', () => (dlg.open ? close() : open()));
    dlg.querySelectorAll('[data-coll-close]').forEach((b) => b.addEventListener('click', close));
    // Clic sur le fond assombri (panneau modal) : on ferme.
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    // Panneau déroulant (non modal) : clic ailleurs ou Échap pour fermer.
    document.addEventListener('click', (e) => {
      if (dlg.open && !dlg.matches(':modal') && !dlg.contains(e.target) && !btn.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dlg.open && !dlg.matches(':modal')) { close(); btn.focus(); }
    });

    // Curseur de prix (reinitialise apres chaque mise a jour du panneau)
    const initRange = () => {
      const range = form.querySelector('[data-price-range]');
      if (!range) return;
      const lo = range.querySelector('[data-range-min]');
      const hi = range.querySelector('[data-range-max]');
      const paint = () => {
        const min = Number(range.dataset.min) || 0;
        const span = (Number(range.dataset.max) - min) || 1;
        if (Number(lo.value) > Number(hi.value)) [lo.value, hi.value] = [hi.value, lo.value];
        range.querySelector('[data-out-min]').textContent = lo.value;
        range.querySelector('[data-out-max]').textContent = hi.value;
        const a = (lo.value - min) / span;
        const b = (hi.value - min) / span;
        range.style.setProperty('--a', `${a * 100}%`);
        range.style.setProperty('--b', `${b * 100}%`);
        const bars = range.querySelectorAll('.coll-range__bars span');
        bars.forEach((bar, i) => {
          const at = (i + 0.5) / bars.length;
          bar.classList.toggle('is-in', at >= a && at <= b);
        });
      };
      lo.addEventListener('input', paint);
      hi.addEventListener('input', paint);
      paint();
    };
    initRange();

    // Adresse a charger d'apres le panneau : une option liee a une sous-categorie (puces du haut)
    // y mene ; le Style passe avant la Couleur ; les autres etiquettes vont dans "constraint".
    const targetUrl = () => {
      const params = new URLSearchParams();
      const range = form.querySelector('[data-price-range]');
      form.querySelectorAll('select[name], input[name]:not([data-tag]):not([type=hidden])').forEach((el) => {
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.name === 'sort_by' && el.value === el.dataset.default) return;
        if (range && el.matches('[data-range-min]') && Number(el.value) <= Number(range.dataset.min)) return;
        if (range && el.matches('[data-range-max]') && Number(el.value) >= Number(range.dataset.max)) return;
        params.append(el.name, el.value);
      });
      const picked = [...form.querySelectorAll('[data-tag]:checked')].filter((i) => i.value);
      const linked = picked.find((i) => i.dataset.href && i.dataset.group === 'style') || picked.find((i) => i.dataset.href);
      const tags = picked.filter((i) => i !== linked).map((i) => i.value);
      if (tags.length) params.set('constraint', tags.join('+'));
      const base = linked ? linked.dataset.href : (form.dataset.hubUrl || form.getAttribute('action'));
      const qs = params.toString();
      return base + (qs ? `?${qs}` : '');
    };

    // Mise a jour sans recharger : en-tete, resultats et panneau remplaces par ceux de la nouvelle page.
    const results = () => document.querySelector('[data-coll-results]');
    const cache = new Map();
    const page = (url) => {
      const key = new URL(url, location.href).href;
      if (!cache.has(key)) cache.set(key, fetch(key).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }));
      return cache.get(key);
    };
    const prefetch = (url) => { if (url) page(url).catch(() => cache.delete(new URL(url, location.href).href)); };
    // Sous-categories (puces et options liees) prechargees a l'ouverture du panneau et au survol.
    const prefetchLinked = () => form.querySelectorAll('[data-tag][data-href]').forEach((i) => prefetch(i.dataset.href));
    btn.addEventListener('pointerenter', prefetchLinked);
    btn.addEventListener('touchstart', prefetchLinked, { passive: true });
    document.addEventListener('pointerover', (e) => {
      const a = e.target.closest?.('.coll-chip');
      if (a) prefetch(a.href);
    });
    document.addEventListener('touchstart', (e) => {
      const a = e.target.closest?.('.coll-chip');
      if (a) prefetch(a.href);
    }, { passive: true });
    let ticket = 0;
    const load = async (url, push = true) => {
      const mine = ++ticket;
      results()?.classList.add('is-loading');
      try {
        const html = await page(url);
        if (mine !== ticket) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const swap = (sel) => {
          const cur = document.querySelector(sel);
          const next = doc.querySelector(sel);
          if (cur && next) cur.replaceWith(next);
        };
        // Le panneau garde ses rubriques ouvertes et sa position : les choix restent sous les yeux.
        const oldBody = form.querySelector('.coll-filters__body');
        const scroll = oldBody?.scrollTop || 0;
        const opened = [...(oldBody?.querySelectorAll('details') || [])].map((d) => d.open);
        swap('.coll-head');
        swap('[data-coll-results]');
        swap('.coll-filters__body');
        const newBody = form.querySelector('.coll-filters__body');
        const groups = newBody ? [...newBody.querySelectorAll('details')] : [];
        if (groups.length === opened.length) groups.forEach((d, i) => { if (opened[i]) d.open = true; });
        if (newBody) newBody.scrollTop = scroll;
        const nextBtn = doc.querySelector('.coll-filter-btn');
        if (nextBtn) btn.innerHTML = nextBtn.innerHTML;
        const nextForm = doc.querySelector('[data-coll-form]');
        if (nextForm) {
          form.setAttribute('action', nextForm.getAttribute('action'));
          if (nextForm.dataset.hubUrl) form.dataset.hubUrl = nextForm.dataset.hubUrl;
          else delete form.dataset.hubUrl;
        }
        document.title = doc.title;
        if (push) history.pushState({ coll: true }, '', url);
        initRange();
        document.dispatchEvent(new CustomEvent('coll:updated'));
      } catch {
        location.href = url;
      }
    };

    // Tout changement (option, prix, tri) met la liste a jour aussitot, panneau ouvert.
    form.addEventListener('change', () => load(targetUrl()));
    form.addEventListener('submit', (e) => { e.preventDefault(); load(targetUrl()); close(); });
    // Puces des sous-categories et pastilles de filtres actifs : meme mise a jour instantanee.
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.coll-chip, .coll-pill, .coll-clear');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      load(a.href);
    });
    window.addEventListener('popstate', () => load(location.href, false));
    try { sessionStorage.removeItem(KEY); } catch {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  /* Onglets Look 1 / 2 / 3 : photo et pieces du look choisi. */
  document.querySelectorAll('[data-stl]').forEach((stl) => {
    stl.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-stl-tab]');
      if (!tab) return;
      const i = tab.dataset.stlTab;
      stl.querySelectorAll('[data-look]').forEach((el) => el.classList.toggle('is-active', el.dataset.look === i));
      stl.querySelectorAll('[data-stl-tab]').forEach((b) => b.setAttribute('aria-selected', String(b === tab)));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
